import { inject, Pipe, PipeTransform } from '@angular/core';
import { StringUtilsService } from '../services/string-utils.service';

@Pipe({
  name: 'searchUser',
  standalone: false,
})
export class SearchUserPipe implements PipeTransform {
  private readonly stringUtilsService = inject(StringUtilsService);
  transform(value: any, query: string) {
    if (query) {
      return value.filter(function (el: any) {
        return (
          el.fullName.toLocaleLowerCase().indexOf(this.stringUtilsService.getNormalizedName(query).toLowerCase()) > -1
        );
      });
    }
    return value;
  }
}
